import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "4d082750-de40-4009-a4b7-59d938593af8",
    content: "Proportional to the stiffness of the diaphragm",
    options: {},
  },
  { id: "c2eec7e2-c8db-4f81-ae18-ac7f3098b5f7", content: "Proportional to the mass of the diaphragm", options: {} },
  { id: "82019828-254c-4151-a34a-63f95bb52521", content: "Proportional to the incident sound pressure ", options: {} },
  { id: "c1918b0f-6cc9-49ed-af31-c719851bccaf", content: "Proportional to the bias voltage", options: {} },
  {
    id: "ced606ea-2036-4fef-a170-08f7553e8039",
    content: "Inversely proportional to the distance<br>between the diaphragm and the rear electrode",
    options: {},
  },
  { id: "8d8c37f5-e0b2-49fe-996a-71802a59753b", content: "Proportional to the area of the diaphragm", options: {} },
];

export const task: Task = {
  id: "e6db6825-d70f-4c34-9041-a6f4210214ad",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    columns: 2,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "c1918b0f-6cc9-49ed-af31-c719851bccaf",
    "ced606ea-2036-4fef-a170-08f7553e8039",
    "8d8c37f5-e0b2-49fe-996a-71802a59753b",
  ],
};
